// @ts-nocheck
import React from 'react'
import { useSelector } from "react-redux"

export const COLUMNS = [
  {
    Header: 'Room Name',
    accessor: 'name',
  },
  {
    Header: 'Room Short Name',
    accessor: 'shortName',
  },
  {
    Header: 'Bed Name',
    accessor: 'bedDetails',
    Cell: ({ cell }) => {
      let bedName = cell?.value?.map((item) => {
        return item['name']
      })
      let str = bedName?.join(', ')

      return <div>{str}</div>
    },
  },
  {
    Header: "",
    accessor: "Edit",
    // @ts-ignore
    Cell: ({ cell }) => {
      // @ts-ignore
      let readOnly = useSelector((state) => state?.user?.readOnly)
      if (readOnly) return null
      else
        return (
          <img
            className="eye-icon"
            src={"assets/images/CRedit.svg"}
            width={32}
            height={30}
            style={{
              marginTop: "6px",
              paddingRight: "15px",
              width: "40px",
              height: "40px",
            }}
            alt="eye"
          />
        )
    },
  },
  {
    Header: "",
    accessor: "Delete",
    // @ts-ignore
    Cell: ({ cell }) => {
      // @ts-ignore
      let readOnly = useSelector((state) => state?.user?.readOnly)
      if (readOnly) return null
      else
        return (
          <img
            className="eye-icon"
            src={"assets/images/CRdelete.svg"}
            width={32}
            height={30}
            style={{
              marginTop: "6px",
              paddingRight: "15px",
              width: "40px",
              height: "40px",
            }}
            alt="eye"
          />
        )
    },
  },
]
